// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'brown', 'brown Fallback'"},"className":"__className_54203e","variable":"__variable_54203e"};